import { render } from "./Index.vue?vue&type=template&id=78050fb1&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=78050fb1&scoped=true&lang=css"
import "./Index.vue?vue&type=style&index=1&id=78050fb1&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78050fb1"],['__file',"components/Pages/Search/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78050fb1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78050fb1', __exports__)) {
    api.reload('78050fb1', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=78050fb1&scoped=true", () => {
    api.rerender('78050fb1', render)
  })

}


export default __exports__